<template>
  <div class="unauthorized-container">
    <div class="unauthorized-content">
      <div class="error-icon">
      <span>Ｘ</span>
    </div>
      <h1 class="unauthorized-title">Unauthorized Access</h1>
      <p class="unauthorized-message">{{ errorMessage }}</p>
      <button @click="goBack" class="back-button">Go Back</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const errorMessage = ref('You do not have permission to access this page');

onMounted(() => {
  if (route.query.message) {
    errorMessage.value = route.query.message;
  }
});

const goBack = () => {
  router.go(-1);
};
</script>

<style scoped>
.unauthorized-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: black;
}

.unauthorized-content {
  text-align: center;
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 90%;
}

.error-icon {
  font-size: 5rem;
  color: #dc3545;
  margin-bottom: 1.5rem;
}

.unauthorized-title {
  color: #dc3545;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.unauthorized-message {
  color: #6c757d;
  margin-bottom: 1.5rem;
  font-size: 1rem;
}

.back-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #0056b3;
}
</style> 